<?xml version="1.0" ?><svg id="Capa_1" style="enable-background:new 0 0 128 128;" version="1.1" viewBox="0 0 128 128" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><style type="text/css">
	.st0{fill:#21A365;}
	.st1{fill:#107C41;}
	.st2{fill:#185B37;}
	.st3{fill:#33C481;}
	.st4{fill:#17864C;}
	.st5{fill:#FFFFFF;}
	.st6{fill:#036C70;}
	.st7{fill:#1A9BA1;}
	.st8{fill:#37C6D0;}
	.st9{fill:#04878B;}
	.st10{fill:#4F59CA;}
	.st11{fill:#7B82EA;}
	.st12{fill:#4C53BB;}
	.st13{fill:#0F78D5;}
	.st14{fill:#29A7EB;}
	.st15{fill:#0358A8;}
	.st16{fill:#0F79D6;}
	.st17{fill:#038387;}
	.st18{fill:#048A8E;}
	.st19{fill:#C8421D;}
	.st20{fill:#FF8F6A;}
	.st21{fill:#ED6B47;}
	.st22{fill:#891323;}
	.st23{fill:#AF2131;}
	.st24{fill:#C94E60;}
	.st25{fill:#E08195;}
	.st26{fill:#B42839;}
	.st27{fill:#0464B8;}
	.st28{fill:#0377D4;}
	.st29{fill:#4FD8FF;}
	.st30{fill:#1681D7;}
	.st31{fill:#0178D4;}
	.st32{fill:#042071;}
	.st33{fill:#168FDE;}
	.st34{fill:#CA64EA;}
	.st35{fill:#7E1FAF;}
	.st36{fill:#AE4BD5;}
	.st37{fill:#9332BF;}
	.st38{fill:#7719AA;}
	.st39{fill:#0078D4;}
	.st40{fill:#1490DF;}
	.st41{fill:#0364B8;}
	.st42{fill:#28A8EA;}
	.st43{fill:#41A5ED;}
	.st44{fill:#2C7BD5;}
	.st45{fill:#195ABE;}
	.st46{fill:#103E91;}
	.st47{fill:#2166C3;}
	.st48{opacity:0.2;}
</style><g><path class="st27" d="M120.2,22.8H34.2V9.1C34.2,6.8,36,5,38.2,5h77.9c2.3,0,4.1,1.8,4.1,4.1V22.8z"/><rect class="st28" height="26.6" width="28.7" x="34.2" y="22.8"/><rect class="st14" height="26.6" width="28.7" x="62.9" y="22.8"/><rect class="st29" height="26.6" width="28.7" x="91.6" y="22.8"/><rect class="st30" height="26.6" width="28.7" x="34.2" y="49.4"/><rect class="st31" height="26.6" width="28.7" x="62.9" y="49.4"/><rect class="st14" height="26.6" width="28.7" x="91.6" y="49.4"/><rect class="st27" height="26.6" width="28.7" x="62.9" y="75.9"/><rect class="st30" height="26.6" width="28.7" x="91.6" y="75.9"/></g><path class="st32" d="M126.9,69.1l-6.6,3.9V61.8l6.5,3.6C128.3,66.1,128.3,68.2,126.9,69.1z"/><path class="st33" d="M126.9,69.1l-0.6,0.4l0,0l-0.7,0.4l-5.3,3.1v-0.1l-88.4,50.6h89.1c3.8,0,6.8-3.1,6.8-6.8l0.1-49.4  C128,67.9,127.6,68.7,126.9,69.1z"/><g><path class="st14" d="M122,123.5H32.8c-3.8,0-6.8-3.1-6.8-6.8V68.5L122,123.5z"/></g><path class="st30" d="M59,96.5h-53c-3.5,0-6.4-2.9-6.4-6.4V37.9c0-3.5,2.9-6.4,6.4-6.4h53c3.5,0,6.4,2.9,6.4,6.4v52.2  C65.4,93.6,62.6,96.5,59,96.5z"/><g><path class="st5" d="M32.5,82.9c-10.3,0-16.8-7.8-16.8-18.2c0-11,7.1-18.8,17.3-18.8c10.6,0,16.8,7.9,16.8,18.1   C49.9,76.1,42.5,82.9,32.5,82.9L32.5,82.9z M32.9,77.7c6.4,0,10-5.9,10-13.4c0-6.8-3.4-13.1-10-13.1s-10.1,6.2-10.1,13.4   S26.4,77.7,32.9,77.7L32.9,77.7z"/></g><path class="st48" d="M65.5,37.3c0,0.2,0,0.4,0,0.6v52.2c0,3.5-2.9,6.4-6.4,6.4H26v5.7h38.4c3.5,0,6.4-2.9,6.4-6.4V43.6  C70.8,40.4,68.5,37.7,65.5,37.3z"/></svg>